import React from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const AppUsersTable = (params: { survey: App.Survey }) => {
  return <Layout {...useProps(params)} />
}
